const ua = navigator.userAgent;

window.addEventListener('DOMContentLoaded', function() {
  if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
    screen.orientation && screen.orientation.lock && screen.orientation.lock('portrait');
  }
});
